var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disease-revenue"},[_c('Title',{attrs:{"type":"普通","title":"疾病收入大盘/7天"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart",attrs:{"id":"diseaseRevenueChart"}})])
}]

export { render, staticRenderFns }